import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useRedirectPageHelper } from "../utilies/utilies";

export default function PromoModal({
  showOnLoad = true,
  image,
  title,
  message,
  buttonText,
  buttonLink
}) {
  const [show, setShow] = useState(false);
  const redirectPageHelper = useRedirectPageHelper();

  useEffect(() => {
    if (showOnLoad) {
      setShow(true);
    }
  }, [showOnLoad]);

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      centered
      backdrop="true"        // allows clicking outside to close
      keyboard={true}        // allows ESC key to close
    >
      <Modal.Header closeButton>  {/* X button */}
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center">
        {image && (
          <img
            src={image}
            alt="Promotion"
            className="img-fluid mb-3"
            style={{ borderRadius: "6px" }}
          />
        )}

        <p>{message}</p>

        <Button
            variant="danger"
            className="w-100 mt-3"
            onClick={() => {
                redirectPageHelper("/inventory", { category: "Valentine's Day" });
                setShow(false);
            }}
        >
        {buttonText}
        </Button>

      </Modal.Body>
    </Modal>
  );
}
